"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySearchToggles = exports.EntitySearchTogglesDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var checkbox_1 = require("../elements/checkbox");
var use_lang_1 = require("../../hooks/use-lang");
var use_statuses_1 = require("../../hooks/use-statuses");
var immer_1 = __importDefault(require("immer"));
var toggle_1 = require("../elements/toggle");
exports.EntitySearchTogglesDefaultProps = {
  showPublishStatus: false,
  showMembershipToggle: false,
  showDuplicatesToggle: false,
  showActiveToggle: false,
  value: {},
  onChange: function (newValue) {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var CheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-size: ", "; \n    margin-left: ", ";\n  "], ["\n    text-transform: uppercase;\n    font-size: ", "; \n    margin-left: ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.UNIT(5))
});
var DraftCheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    margin-left: 0;\n  "], ["\n    ", ";\n    margin-left: 0;\n  "])), CheckboxStyles)
});
var PublishedCheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), CheckboxStyles)
});
var TogglesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    div:first-child {\n      background: none;\n      padding-left: 0;\n      margin-left: 0;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    div:first-child {\n      background: none;\n      padding-left: 0;\n      margin-left: 0;\n    }\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    justify-content: flex-start;\n  "], ["\n    justify-content: flex-start;\n  "])))
});
var ToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-left: ", ";\n    padding-left: ", ";\n  "], ["\n    margin-left: ", ";\n    padding-left: ", ";\n  "])), theme_1.theme.UNIT(2.5), theme_1.theme.UNIT(2.5)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n    padding-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n    padding-left: ", ";\n  "])), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4), theme_1.theme.UNIT(5.5), theme_1.theme.UNIT(5.5))
});
var PublishStatusStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    display: flex;\n    align-items: center;\n  "], ["\n    flex-wrap: nowrap;\n    display: flex;\n    align-items: center;\n  "])))
});
var ActiveToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ToggleStyles)
});
var MembershipToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    \n  "], ["\n    ", ";\n    \n  "])), ToggleStyles)
});
var DuplicatesToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ToggleStyles)
});
var DraftToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ToggleStyles)
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  PublishStatus: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), PublishStatusStyles),
  DraftCheckbox: (0, styled_components_1.default)(checkbox_1.Checkbox)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), DraftCheckboxStyles),
  PublishedCheckbox: (0, styled_components_1.default)(checkbox_1.Checkbox)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PublishedCheckboxStyles),
  Toggles: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TogglesStyles),
  ActiveToggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ActiveToggleStyles),
  DuplicatesToggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), DuplicatesToggleStyles),
  MembershipToggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MembershipToggleStyles),
  DraftToggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DraftToggleStyles)
};
var EntitySearchToggles = function (props) {
  var className = props.className,
    showActiveToggle = props.showActiveToggle,
    showDraftToggle = props.showDraftToggle,
    showMembershipToggle = props.showMembershipToggle,
    showDuplicatesToggle = props.showDuplicatesToggle,
    value = props.value,
    onChange = props.onChange;
  var _a = (0, use_statuses_1.useStatuses)(),
    publishedStatus = _a.publishedStatus,
    draftStatus = _a.draftStatus;
  var t = (0, use_lang_1.useLang)();
  var onActiveToggleChange = function () {
    var newState = (0, immer_1.default)(value, function (draft) {
      if (!!draft.isActive) {
        delete draft.isActive;
        draft.isAll = {
          is: true
        };
      } else {
        draft.isActive = {
          is: true
        };
        delete draft.isAll;
      }
      return draft;
    });
    onChange(newState);
  };
  var onMembershipToggleChange = function () {
    var newState = (0, immer_1.default)(value, function (draft) {
      if (!!draft.isMember) {
        delete draft.isMember;
      } else {
        draft.isMember = {
          is: true
        };
      }
      return draft;
    });
    onChange(newState);
  };
  var onDraftToggleChange = function () {
    var newState = (0, immer_1.default)(value, function (draft) {
      if (!!draft.isDraft) {
        delete draft.isDraft;
        draft.isPublished = {
          is: true
        };
      } else {
        draft.isDraft = {
          is: true
        };
        delete draft.isPublished;
      }
      return draft;
    });
    onChange(newState);
  };
  var onDuplicatesToggleChange = function () {
    var newState = (0, immer_1.default)(value, function (draft) {
      draft.duplicatesOnly = !draft.duplicatesOnly;
      return draft;
    });
    onChange(newState);
  };
  var activeLabel = t('Active');
  var membershipLabel = t('Members');
  var onLabel = t('All');
  var isActiveToggleAll = !value.isActive;
  var isMembershipToggleAll = !value.isMember;
  var isDraftTogglePublished = !value.isDraft;
  var isDuplicatesOnly = !!value.duplicatesOnly;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Toggles, null, showDuplicatesToggle && react_1.default.createElement(My.DuplicatesToggle, {
    onClick: onDuplicatesToggleChange,
    isOffColor: "primary",
    isOnColor: "primary",
    offLabel: 'All',
    onLabel: t('Duplicates'),
    isOn: isDuplicatesOnly
  }), showDraftToggle && react_1.default.createElement(My.DraftToggle, {
    onClick: onDraftToggleChange,
    isOffColor: "primary",
    isOnColor: "primary",
    offLabel: t((draftStatus === null || draftStatus === void 0 ? void 0 : draftStatus.name) || 'Draft'),
    onLabel: t((publishedStatus === null || publishedStatus === void 0 ? void 0 : publishedStatus.name) || 'Published'),
    isOn: isDraftTogglePublished
  }), showActiveToggle && react_1.default.createElement(My.ActiveToggle, {
    onClick: onActiveToggleChange,
    isOffColor: "primary",
    isOnColor: "primary",
    offLabel: activeLabel,
    onLabel: onLabel,
    isOn: isActiveToggleAll
  }), showMembershipToggle && react_1.default.createElement(My.MembershipToggle, {
    onClick: onMembershipToggleChange,
    isOffColor: "primary",
    isOnColor: "primary",
    offLabel: membershipLabel,
    onLabel: onLabel,
    isOn: isMembershipToggleAll
  })));
};
exports.EntitySearchToggles = EntitySearchToggles;
exports.EntitySearchToggles.defaultProps = exports.EntitySearchTogglesDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;